import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskPriorityLow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 11C3 10.4477 3.44772 10 4 10C4.55228 10 5 10.4477 5 11V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V11Z",
			fill: "#515D71"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 7,
			width: 2,
			height: 7,
			rx: 1,
			fill: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V5Z",
			fill: "#C2C7D1"
		})
	]
});
export default SvgTaskPriorityLow;
